import React from 'react';
import { Image } from '@landing/ui';
import { useStateModal, useWindowResize } from 'utils/hooks';
import { GalleryModal } from 'components/Modals';

import * as styles from './ArtImage.module.scss';

export default function ArtImage({ item, index, items, name, year, setPopupOpen }) {
  const { width } = useWindowResize();
  const { modalState, showModal, hideModal } = useStateModal();

  const showPopup = () => {
    showModal();
    setPopupOpen(true);
  };

  const hidePopup = () => {
    hideModal();
    setPopupOpen(false);
  };

  const getWidth = () => {
    if (width > 1025) return 530;
    if (width > 545) return 330;
    return 265;
  };

  return (
    <div style={{ width: getWidth() }}>
      <div className={styles.item} onClick={showPopup}>
        <Image className={styles.picture} classImage={styles.image} src={item.image} />
      </div>
      {modalState.isOpen && (
        <GalleryModal
          isOpen={modalState.isOpen}
          closeModalCallback={hidePopup}
          items={items}
          index={index}
          name={name}
          year={year}
          theme="vertical"
        />
      )}
    </div>
  );
}
